module.exports = __webpack_public_path__ + "static/media/2.17116987.jpg";